import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { plainToInstance } from 'class-transformer';
import { Diet } from '../models/diet.model';

@Injectable({
  providedIn: 'root'
})
export class DietService {

  private apiUrl = `${environment.sgcApi}`;
  private dietRoute = 'diet';

  constructor(
    private httpClient: HttpClient
  ) {}

  getDiets(): Observable<Diet[]> {
    let endpoint = `${this.apiUrl}${this.dietRoute}/map`;
    return this.httpClient.get<Diet[]>(endpoint)
    .pipe(map((data) => {
      return plainToInstance(Diet, data as Diet[]);
    }));
  }
}
